<ui-confirmation-dialog
    #deleteConfirmationDialog
    [header]="'payroll.benefits.deleteBenefit'"
    primaryButtonLabel="confirm"
    secondaryButtonLabel="cancel"
>
    <p>{{ 'payroll.benefits.areYouSureYouWishToDeleteThisBenefit' | translate }}</p>
</ui-confirmation-dialog>

<div class="page-container" [class.loading]="isLoading">
    <app-header title="benefits.planIndex.title" [menuService]="benefitsMenuService">
        @if (!isNotAccessible) {
            <div class="buttons">
                <ui-button type="primary" [routerLink]="['upload-invoice']">
                    {{ 'benefits.benefitsPayroll.uploadBillingStatement' | translate }}
                </ui-button>
            </div>
        }
    </app-header>

    @if (isNotAccessible) {
        <ui-card class="empty-state">
            <h2>{{ 'benefits.benefitsPayroll.streamlineBenefitsDeductionsInPayroll' | translate }}</h2>

            <p class="neutral-dark">
                {{ 'benefits.benefitsPayroll.keepingPayrollInSyncWithBenefitsChagnes' | translate }}
            </p>

            <h4>
                <mat-icon svgIcon="bulb"></mat-icon>
                {{ 'benefits.benefitsPayroll.howItWorks' | translate }}
            </h4>

            <div class="how-it-works">
                <ui-card variant="outline">
                    <div class="margin-bottom-2">
                        <img src="/assets/icons/generic/setup-benefits.svg" />
                    </div>
                    <div class="neutral-dark font-large margin-bottom-1">
                        {{ 'benefits.benefitsPayroll.steps.step1' | translate }}
                    </div>
                    <div class="font-large margin-bottom-1">
                        <strong>{{ 'benefits.benefitsPayroll.steps.step1Title' | translate }}</strong>
                    </div>
                    <p class="neutral-dark">
                        {{ 'benefits.benefitsPayroll.steps.step1Description' | translate }}
                    </p>
                </ui-card>

                <ui-card variant="outline">
                    <div class="margin-bottom-2">
                        <img src="/assets/icons/generic/upload-statement.svg" />
                    </div>
                    <div class="neutral-dark font-large margin-bottom-1">
                        {{ 'benefits.benefitsPayroll.steps.step2' | translate }}
                    </div>
                    <div class="font-large margin-bottom-1">
                        <strong>{{ 'benefits.benefitsPayroll.steps.step2Title' | translate }}</strong>
                    </div>
                    <p class="neutral-dark">
                        {{ 'benefits.benefitsPayroll.steps.step2Description' | translate }}
                    </p>
                </ui-card>

                <ui-card variant="outline">
                    <div class="margin-bottom-2">
                        <img src="/assets/icons/generic/sync-to-payroll.svg" />
                    </div>
                    <div class="neutral-dark font-large margin-bottom-1">
                        {{ 'benefits.benefitsPayroll.steps.step3' | translate }}
                    </div>
                    <div class="font-large margin-bottom-1">
                        <strong>{{ 'benefits.benefitsPayroll.steps.step3Title' | translate }}</strong>
                    </div>
                    <p class="neutral-dark">
                        {{ 'benefits.benefitsPayroll.steps.step3Description' | translate }}
                    </p>
                </ui-card>
            </div>

            <ui-banner [variant]="'info'" iconOverride="lock">
                {{ 'benefits.benefitsPayroll.thisFeatureIsCurrentlyInBeta' | translate }}

                <ui-button
                    class="margin-left-auto"
                    type="primary"
                    (click)="contactClicked()"
                    [disabled]="contactUsButtonDisabled"
                    >{{ 'benefits.benefitsPayroll.contactUs' | translate }}</ui-button
                >
            </ui-banner>
        </ui-card>
    } @else {
        @if (route.snapshot.data.isPayrollPending) {
            <ui-banner class="margin-bottom-4" [variant]="'warning'">
                <p class="flag-content">{{ 'benefits.benefitsPayroll.pendingPayrollNotice' | translate }}</p>
            </ui-banner>
        }

        <ui-card [withSpacing]="false">
            <app-table
                *ngIf="table"
                [title]="'benefits.benefitsPayroll.connectBenefitsWithPayroll' | translate"
                [table]="table"
                [showSearch]="false"
                [isResponsive]="true"
                [embedded]="true"
                [noPadding]="true"
                (menuItemSelected)="menuAction($event)"
            >
                <div class="buttons">
                    <ui-button type="outline" [disabled]="route.snapshot.data.isPayrollPending" url="connect-benefit"
                        ><mat-icon svgIcon="plus"></mat-icon>
                        {{ 'benefits.benefitsPayroll.addBenefits' | translate }}</ui-button
                    >
                </div>

                <app-empty-state
                    class="empty-state"
                    label="benefits.benefitsPayroll.noBenefitsConnected"
                    src="/assets/illustrations/desktop.png"
                ></app-empty-state>
            </app-table>
        </ui-card>

        <ui-card [withSpacing]="false">
            <app-table
                *ngIf="benefitsInvoiceTable"
                [title]="'benefits.benefitsPayroll.monthlyBenefitsAdjustment' | translate"
                [table]="benefitsInvoiceTable"
                [showSearch]="false"
                [isResponsive]="true"
                [embedded]="true"
                [noPadding]="true"
            >
                <app-empty-state
                    class="empty-state"
                    label="benefits.benefitsPayroll.noInvoicesUploaded"
                    src="/assets/illustrations/desktop.png"
                ></app-empty-state>
            </app-table>
        </ui-card>
    }
</div>
